import React from 'react'
import { CCard, CCardBody, CCardHeader } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import {
  cilCheckCircle,
  cilDollar,
  cilFilter,
  cilGroup,
  cilLockUnlocked,
  cilPeople,
  cilStar,
  cilStarHalf,
  cilTransfer,
} from '@coreui/icons'

const SummaryRow = ({ icon, label, value }) => (
  <div className="d-flex justify-content-between align-items-center mb-3">
    <div className="d-flex align-items-center text-medium-emphasis">
      <CIcon icon={icon} className="me-2" />
      {label}
    </div>
    <strong>{value}</strong>
  </div>
)

const TIPS = [
  'Set a balanced salary cap for a competitive game.',
  'Limiting players per team increases variety.',
  'PCR helps manage star player dominance.',
  'You can change these settings later before the game is activated.',
]

const GameStructureSummary = ({ values, pcrTermLabel, currencySymbol = '$' }) => {
  const maxPerTeamLabel =
    Number(values.max_players_per_team) === 0
      ? 'No Limit'
      : `${values.max_players_per_team} Players`

  const pcrLimitLabel = values.pcr_enabled
    ? `${Number(values.pcr_min_players) > 0 ? `${values.pcr_min_players}-` : ''}${
        values.pcr_max_players
      } ${pcrTermLabel || ''}`.trim()
    : 'Disabled'

  return (
    <>
      <CCard className="mb-4">
        <CCardHeader>
          <strong>Game Structure Summary</strong>
        </CCardHeader>
        <CCardBody>
          <SummaryRow
            icon={cilGroup}
            label="Team Size"
            value={`${values.team_size || '-'} Players`}
          />
          <SummaryRow
            icon={cilDollar}
            label="Salary Cap"
            value={`${currencySymbol}${values.salary_cap || 0}m`}
          />
          <SummaryRow
            icon={cilTransfer}
            label="Total Trades"
            value={`${values.trades || 0} Trades`}
          />
          <SummaryRow icon={cilPeople} label="Max Per Team" value={maxPerTeamLabel} />
          <SummaryRow icon={cilFilter} label="PCR Limit" value={pcrLimitLabel} />
          <SummaryRow icon={cilStar} label="Captain" value="2x Points" />
          <SummaryRow icon={cilStarHalf} label="Vice-Captain" value="1.5x Points" />
          <SummaryRow icon={cilStar} label="Triple Captain" value="3x Points" />
          <SummaryRow
            icon={cilLockUnlocked}
            label="Visibility"
            value={Number(values.game_visibility) === 2 ? 'Private' : 'Public'}
          />
        </CCardBody>
      </CCard>

      <CCard className="mb-4">
        <CCardHeader>Tips</CCardHeader>
        <CCardBody>
          {TIPS.map((tip, index) => (
            <div key={index} className={index < TIPS.length - 1 ? 'mb-2' : ''}>
              <CIcon icon={cilCheckCircle} className="text-success me-2" />
              {tip}
            </div>
          ))}
        </CCardBody>
      </CCard>
    </>
  )
}

export default GameStructureSummary
